"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var realtime_subscriptions_1 = __importDefault(require("../realtime-subscriptions"));
var internal_types_1 = require("./internal-types");
var TaskManagedAttributesRealtimeSubscriptions = /** @class */ (function () {
    function TaskManagedAttributesRealtimeSubscriptions(session, store, storableDataService) {
        this.updateListeners = [];
        this.realtimeSubscriptions = new realtime_subscriptions_1.default(session);
        this.tasksManagedAttributesStore = store;
        this.storableDataService = storableDataService;
    }
    TaskManagedAttributesRealtimeSubscriptions.prototype.updateStoreOnEvents = function () {
        var _this = this;
        this.realtimeSubscriptions.subscribe(internal_types_1.TaskManagedAttributesRealTimeEvents.TASK_MANAGED_ATTRIBUTE_UPDATE, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                this.storableDataService.updateInStores((_a = {
                        id: event.task_id
                    },
                    _a[event.name] = event.value,
                    _a));
                this.emitUpdate(event);
                return [2 /*return*/];
            });
        }); });
        this.realtimeSubscriptions.subscribe(internal_types_1.TaskManagedAttributesRealTimeEvents.TASK_MANAGED_ATTRIBUTE_DELETE, function (event) {
            var attribute = _this.tasksManagedAttributesStore.get(event.task_id);
            if (!attribute) {
                // eslint-disable-next-line no-console
                console.warn("Received delete event for task managed attribute ".concat(event.name, " on task ").concat(event.task_id, ", but it does not exist in the store."));
                return;
            }
            delete attribute[event.name];
            if (_this.isEmptyAttribute(attribute)) {
                _this.storableDataService.removeFromStores(event.task_id);
            }
        });
    };
    TaskManagedAttributesRealtimeSubscriptions.prototype.isEmptyAttribute = function (attribute) {
        return attribute.id !== undefined && Object.keys(attribute).length === 1;
    };
    TaskManagedAttributesRealtimeSubscriptions.prototype.emitUpdate = function (event) {
        this.updateListeners.forEach(function (listener) {
            try {
                listener(event);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.error('Error in update listener', e);
            }
        });
    };
    TaskManagedAttributesRealtimeSubscriptions.prototype.onUpdate = function (callback) {
        var _this = this;
        this.updateListeners.push(callback);
        var unsubscribed = false;
        return function () {
            if (unsubscribed) {
                return;
            }
            var indexOfListener = _this.updateListeners.indexOf(callback);
            if (indexOfListener !== -1) {
                _this.updateListeners.splice(indexOfListener, 1);
            }
            unsubscribed = true;
        };
    };
    TaskManagedAttributesRealtimeSubscriptions.prototype.resetAllListeners = function () {
        this.updateListeners = [];
    };
    return TaskManagedAttributesRealtimeSubscriptions;
}());
exports.default = TaskManagedAttributesRealtimeSubscriptions;
//# sourceMappingURL=task-managed-attributes-realtime-subscriptions.js.map